import { Country } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface CountriesLoadingState {
    loading: boolean;
    projectManagementSaving: boolean;
}

export interface CountriesState {
    countries: Country[] | undefined;
    loaded: boolean;
    loading: CountriesLoadingState;
    error: AppError | null;
}

export const initialCountriesState: CountriesState = {
    countries: undefined,
    loaded: false,
    loading: { loading: false, projectManagementSaving: false },
    error: null,
};
